import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';

const { Box, ActionButton } = designSystem;

const DifmOrderFormFooter = ({
  backButtonLabel,
  submitButtonLabel,
  nextButtonLabel,
  showBackButton,
  showSubmitButton,
  isDesktopView,
  onBackButtonClick,
  onSubmitButtonClick,
  onNextButtonClick,
}) => (
  <div
    className={classNames('ws-difm-order-form-footer', {
      'ws-difm-order-form-footer--desktop-view': isDesktopView,
    })}
  >
    <Box
      {...(isDesktopView
        ? {
            padding: 'spacing-xl',
            paddingTop: 'spacing-xs',
            paddingBottom: 'spacing-xs',
          }
        : {
            padding: 'spacing-xs',
          })}
    >
      <div className="ws-difm-order-form-footer__box">
        {showBackButton && (
          <ActionButton
            format="text"
            iconGlyph="back"
            size="large"
            label={backButtonLabel}
            onClick={onBackButtonClick}
          />
        )}
        {(showSubmitButton && (
          <ActionButton
            appearance="accent"
            format="solid"
            size="large"
            label={submitButtonLabel}
            onClick={onSubmitButtonClick}
            {...(!isDesktopView && { fullWidth: true })}
          />
        )) || (
          <ActionButton
            appearance="accent"
            format="solid"
            iconGlyph="next"
            iconPlacement="after"
            size="large"
            label={nextButtonLabel}
            onClick={onNextButtonClick}
            {...(!isDesktopView && { fullWidth: true })}
          />
        )}
      </div>
    </Box>
  </div>
);

DifmOrderFormFooter.propTypes = {
  backButtonLabel: PropTypes.string.isRequired,
  submitButtonLabel: PropTypes.string.isRequired,
  nextButtonLabel: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  showSubmitButton: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onSubmitButtonClick: PropTypes.func.isRequired,
  onNextButtonClick: PropTypes.func.isRequired,
};

export default DifmOrderFormFooter;
